import React, { useEffect } from 'react';
import { useFetch } from 'hooks/use-fetch';

const PartnerCookieHandler: React.FC = () => {
    let partner = 0;
    let ad = 0;
    let ref = '';
    const { post } = useFetch('/pp', {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
    });

    const init = (): void => {
        const pattern = /(%23|#)from([0-9]+)(ad([0-9]+))?/i;
        const url = document.URL;
        const parts = pattern.exec(url);

        if (parts !== null && parts[2] !== void 0) {
            partner = parseInt(parts[2]);

            if (parts[4] !== void 0) {
                ad = parseInt(parts[4]);
            }
        }

        ref = document.referrer;
    };

    const visit = (): void => {
        if (partner !== 0) {
            post(new URLSearchParams({
                partnerNo: partner.toString(),
                adNo: ad.toString(),
                partnerRef: ref,
                ppLoc: document.location.href
            }).toString());
        }
    };

    const clearCookies = (): void => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        if (
            (document.referrer && document.referrer.split('/')[2] !== document.location.host)
            || urlParams.get('gclid')
            || urlParams.get('fbclid')
            || (urlParams.get('utm_source') && urlParams.get('utm_medium') && urlParams.get('utm_medium') !== 'pp')
            || urlParams.get('_rw_onet_click')
            || urlParams.get('utm_source') && urlParams.get('utm_source') === 'rtbhouse'
        ) {
            const cookieNames = [
                'skapiec_pp',
                'skapiec_pp_visit',
                'skapiec_pp_ref'
            ];
            const cookieNamesLength = cookieNames.length;
            const domain = `.${document.location.host.split('.').slice(-2).join('.')}`;

            for (let i = 0; i < cookieNamesLength; i++) {
                document.cookie = `${cookieNames[i]}=deleted; expires = Thu, 01 Jan 1970 00:00:00 GMT; domain = ${domain}; path = /;`;
            }
        }
    };

    useEffect(() => {
        init();
        clearCookies();
        visit();
    }, []);

    return null;
};

export default PartnerCookieHandler;
